import React from 'react';
import JavascriptTimeAgo from 'javascript-time-ago';
import ReactTimeAgo from 'react-time-ago';
import en from 'javascript-time-ago/locale/en';

JavascriptTimeAgo.addLocale(en);

const TimeAgo = ({ className, dateTime, empty }) => {
    if (!dateTime) {
        return empty ?? null;
    }

    return <ReactTimeAgo className={'capitalize ' + className}
        date={new Date(dateTime.replace(' ', 'T'))}
    />
}

export default TimeAgo;
